import React, { useState } from 'react';
import { MenuIcon, XIcon } from 'lucide-react';
export function Header() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const navItems = [{
    label: 'Benefici',
    href: '#benefici'
  }, {
    label: 'Programma',
    href: '#programma'
  }, {
    label: 'Evidenze',
    href: '#evidenze'
  }, {
    label: 'Storia',
    href: '#storia'
  }, {
    label: 'Prezzo',
    href: '#prezzo'
  }, {
    label: 'FAQ',
    href: '#faq'
  }, {
    label: 'Garanzia',
    href: '#garanzia'
  }];
  const handleNavClick = (e: React.MouseEvent<HTMLAnchorElement>, href: string) => {
    e.preventDefault();
    const element = document.querySelector(href);
    if (element) {
      element.scrollIntoView({
        behavior: 'smooth'
      });
      setIsMenuOpen(false);
    }
  };
  return <header className="w-full bg-white border-b border-gray-200 sticky top-0 z-50" data-id="element-83">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-84">
        <div className="flex justify-between items-center py-4" data-id="element-85">
          <div className="flex-1" data-id="element-86">
            <h1 className="text-2xl md:text-3xl font-bold text-gray-900" data-id="element-87">
              VitaCognitiva
            </h1>
          </div>
          {/* Hamburger Menu Button - Always Visible */}
          <button onClick={() => setIsMenuOpen(!isMenuOpen)} className="p-2 rounded-lg hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-green-500" aria-label={isMenuOpen ? 'Chiudi menu' : 'Apri menu'} aria-expanded={isMenuOpen} data-id="element-88">
            {isMenuOpen ? <XIcon size={28} data-id="element-89" /> : <MenuIcon size={28} data-id="element-90" />}
          </button>
        </div>
        {/* Navigation Menu */}
        {isMenuOpen && <nav className="pb-4 border-t border-gray-200 mt-2 pt-4" data-id="element-91">
            {navItems.map(item => <a key={item.href} href={item.href} onClick={e => handleNavClick(e, item.href)} className="block py-3 text-gray-700 hover:text-green-600 hover:bg-gray-50 px-4 rounded-lg transition-colors font-medium focus:outline-none focus:ring-2 focus:ring-green-500" data-id="element-92">
                {item.label}
              </a>)}
          </nav>}
      </div>
    </header>;
}